import axios from "axios";
import store from "@/store";
import TokenService from "./token.service";
import { localStorageName } from "@/config/utils";

// Dedicated axios instance for member-auth calls that must hit the CRM api
// (VUE_APP_BASE_MINTY_URL), not the ordering api used by the default api.js.
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_MINTY_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }

    const merchantCode =
      store.state.merchantCode ||
      localStorage.getItem(localStorageName("MERCHANT_CODE")) ||
      "";
    const merchantId = localStorage.getItem(localStorageName("MERCHANT_ID")) || "";

    config.headers["MerchantCode"] = merchantCode;
    config.headers["MerchantId"] = merchantId;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
